// @core/api/endpoints/webhook/get_webhook_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  WebhookPolicyResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Get webhook policy
 * Returns a webhook policy by ID.
 */
export async function GetWebhookPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<WebhookPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/webhook-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<WebhookPolicyResponse>(requestPath, { ...requestOptions });
}
